import React from "react";
import "./ErrorMessage.scss";

type Props = {
  handleError: Function;
  error: any;
};

export const ErrorMessage: React.FC<Props> = ({ error,  handleError }: Props) => {
  const handleClick = () => {
    handleError();
  };
// console.log(error)
  return (
    <div className="error-message">
      <div className="error-message__content">
        <h1 className="error-message__text">{error.ErrorMessage}</h1>
        {error.ErrorType !== "InvalidAuthentication" && (
          <button className="error-message__refresh" onClick={handleClick}>
          </button>
        )}
      </div>
    </div>
  );
};
